import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { needsAuth } from './utils/authHoc';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { I18n } from 'react-redux-i18n';

import { CardTitle, CardBody, Plus } from '@ui/ShopCard/partials';

import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import {
  WhatsappIcon,
  WhatsappShareButton,
  FacebookShareButton,
  FacebookIcon,
  TelegramIcon,
  TelegramShareButton,
  TwitterShareButton,
  TwitterIcon,
  VKIcon,
  VKShareButton,
  EmailShareButton,
  EmailIcon,
} from 'react-share';
import { userApi } from '@api/index';

const Invitation = ({ user }) => {
  const link = `https://progkids.com/?utm_source=ref&utm_medium=${user.id}`;
  const [visits, setVisits] = useState(0);
  const [sales, setSales] = useState(0);
  const [leads, setLeads] = useState(0);

  useEffect(() => {
    userApi.getInvitationStats().then(res => {
      setVisits(res.visits);
      setSales(res.sales);
      setLeads(res.leads);
    });
  }, []);
  const ShareComponent = ({ Button, Icon }) => (
    <span className="share-button-wrap">
      <Button url={link} title="ProgKids" separator=":: ">
        <Icon size={32} round />
      </Button>
    </span>
  );

  return (
    <div className="container-fluid new-style select-plan code-gray-bg">
      <Row>
        <Col xs={12} mdOffset={3} md={6} className="form-group">
          <Col xs={12} className="card card-green">
            <CardTitle> {I18n.t('invitation.inviteTitle')} </CardTitle>

            <CardBody>
              <div className="title">{I18n.t('invitation.inviteSubTitle')}</div>
              <Plus> {I18n.t('invitation.termsForPresent.term1')} </Plus>
              <Plus> {I18n.t('invitation.termsForPresent.term2')} </Plus>
              <Plus> {I18n.t('invitation.termsForPresent.term3')} </Plus>
              <br />
              <br />
              {I18n.t('invitation.copyLink')}
              <Col xs={12} md={10} className="input-group">
                <input
                  type="text"
                  className="form-control"
                  defaultValue={link}
                />
                <div className="input-group-addon">
                  <CopyToClipboard text={link}>
                    <button className="btn">
                      <i className="fa fa-copy" />{' '}
                      {I18n.t('invitation.copyLinkButton')}
                    </button>
                  </CopyToClipboard>
                </div>
              </Col>
              <br />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {I18n.t('invitation.socialNetworkTitle')} &nbsp; &nbsp;
                <ShareComponent Button={VKShareButton} Icon={VKIcon} />
                <ShareComponent
                  Button={TelegramShareButton}
                  Icon={TelegramIcon}
                />
                <ShareComponent
                  Button={TwitterShareButton}
                  Icon={TwitterIcon}
                />
                <ShareComponent
                  Button={FacebookShareButton}
                  Icon={FacebookIcon}
                />
                <ShareComponent
                  Button={WhatsappShareButton}
                  Icon={WhatsappIcon}
                />
                <ShareComponent Button={EmailShareButton} Icon={EmailIcon} />
              </div>
            </CardBody>

            <CardTitle>
              <Col xs={4}>
                {visits}
                <br />
                {I18n.t('invitation.visits')}
              </Col>
              <Col xs={4}>
                {leads}
                <br />
                {I18n.t('invitation.leads')}
              </Col>
              <Col xs={4}>
                {sales}
                <br />
                {I18n.t('invitation.sales')}
              </Col>
              <br />
              <br />
            </CardTitle>
          </Col>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.auth.user,
  };
};

export default compose(
  needsAuth,
  connect(mapStateToProps)
)(Invitation);
